<template>
  <div>
    <section class="section">
      <div class="container">
        <TituloPrincipal :titulo="titulo" :subtitulo="subtitulo"/>
        <form @submit.prevent>
          <div class="columns is-multiline">
            <div class="column is-4">
              <b-field
                label="Nueva Contraseña"
                :type="{'is-danger': errors.has('nueva contraseña')}"
                :message="errors.first('nueva contraseña')"
              >
                <b-input
                  type="password"
                  v-model="nuevaContrasena"
                  name="nueva contraseña"
                  v-validate="'required|min:8'"
                  v-on:keyup.enter="resetearContrasena()"
                />
              </b-field>
            </div>
            <div class="column is-4">
              <b-field
                label="Confirmar Nueva Contraseña"
                :type="{'is-danger': errors.has('confirmar nueva contraseña')}"
                :message="errors.first('confirmar nueva contraseña')"
              >
                <b-input
                  type="password"
                  v-model="confirmarNuevaContrasena"
                  name="confirmar nueva contraseña"
                  v-validate="{ required: true, is: nuevaContrasena }"
                  v-on:keyup.enter="resetearContrasena()"
                />
              </b-field>
            </div>
            <div class="column is-4">
              <b-field
                label="Verificación"
                :type="{'is-danger': !recaptchaVerified}"
                :message="{'Debe validar que es humano': !recaptchaVerified && showErrorRecaptcha, '': recaptchaVerified}"
              >
                <template>
                  <vue-recaptcha
                    :sitekey="keyRecaptcha"
                    @verify="markRecaptchaAsVerified"
                    @expired="markRecaptchaAsNotVerified"
                  ></vue-recaptcha>
                </template>
              </b-field>
            </div>

            <div class="column is-6">
              <button
                class="button is-secundary"
                v-bind:class="{'is-loading': isLoading}"
                @click="resetearContrasena()"
                v-on:keyup.enter="resetearContrasena()"
              >Cambiar Contraseña</button>
              <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import TituloPrincipal from '@/components/TituloPrincipal.vue'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'ResetPassword',
  data () {
    return {
      titulo: 'Resetear Contraseña',
      subtitulo: 'Ingrese su nueva contraseña',
      token: this.$route.params.token,
      isLoading: false,
      nuevaContrasena: null,
      confirmarNuevaContrasena: null,
      recaptchaVerified: false,
      showErrorRecaptcha: false,
      keyRecaptcha: process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY
    }
  },
  components: {
    TituloPrincipal,
    VueRecaptcha
  },
  methods: {
    markRecaptchaAsVerified (token) {
      this.recaptchaVerified = true
      this.recaptchaToken = token
    },
    markRecaptchaAsNotVerified () {
      this.recaptchaVerified = false
    },
    resetearContrasena () {
      var componenteVue = this
      this.showErrorRecaptcha = true

      function resetearContrasenaCallback (error, data) {
        componenteVue.isLoading = false
        if (error) {
          componenteVue.$buefy.dialog.alert({
            title: 'Error - ' + error.response.data.status,
            message: error.response.data.message,
            type: 'is-danger',
            hasIcon: true,
            icon: 'close-circle-outline',
            iconPack: 'mdi',
            onConfirm: () => componenteVue.$router.push({ name: 'inicio' })
          })
        } else {
          componenteVue.$buefy.dialog.alert({
            title: 'Contraseña Modificada',
            message: data.message,
            type: 'is-success',
            hasIcon: true,
            icon: 'account-check',
            iconPack: 'mdi',
            onConfirm: () => componenteVue.$router.push({ name: 'inicio' })
          })
        }
      }

      // Valida el form (y valida el recaptcha)
      this.$validator.validateAll().then(result => {
        // Si esta todo bien realiza el llamado a resetear contraseña en la api y ejecuta callback
        if (result && this.recaptchaVerified) {
          // Crea el json
          const jsonData = {
            nuevaContrasena: this.nuevaContrasena,
            confirmarNuevaContrasena: this.confirmarNuevaContrasena,
            recaptchaToken: this.recaptchaToken
          }
          this.isLoading = true
          // Ejecuta llamdo sobre api
          componenteVue.$apiService.resetearContrasena(
            this.token,
            jsonData,
            resetearContrasenaCallback
          )
        } else {
          // Sino renderiza toast con error
          this.isLoading = false
          componenteVue.$buefy.toast.open({
            message: 'Revise los datos',
            type: 'is-danger',
            position: 'is-top'
          })
        }
      })
    }
  },
  beforeCreate () {
    // Agrega recaptcha js
    const recaptcha = document.createElement('script')
    recaptcha.setAttribute(
      'src',
      'https://www.google.com/recaptcha/api.js?hl=es-419&onload=vueRecaptchaApiLoaded&render=explicit'
    )
    recaptcha.setAttribute('async', true)
    recaptcha.setAttribute('defer', true)
    document.head.appendChild(recaptcha)
  },
  mounted () {
    const dict = {
      custom: {
        'confirmar nueva contraseña': {
          is: 'Las contraseñas no coinciden'
        }
      }
    }

    this.$validator.localize('es', dict)
  }
}
</script>
